import PlaylistService from "@/services/Playlistservice";
import router from "@/router";
import { sortStreams } from "../../utils";

const defaultState = () => ({
  playList: null,
  sortBy: "Sort by Oldest",
  isLoading: false,
  isLoaded: false,
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  GET_PLAYLIST(state, playlist) {
    state.playList = playlist.reverse();
    state.isLoaded = true;
    state.isLoading = false;
  },
  SET_SORT_OPTION(state, option) {
    state.sortBy = option;
  },
};

const actions = {
  async getPlaylist({ commit, state }, forceRefresh = false) {
    if (state.isLoaded && !forceRefresh) {
      return state.playList;
    }

    if (state.isLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading) {
            clearInterval(checkLoading);
            resolve(state.playList);
          }
        }, 50);
      });
    }

    commit("SET_LOADING", true);
    try {
      const playlist = await PlaylistService.getPlaylist();
      commit("GET_PLAYLIST", playlist);
      return state.playList;
    } catch (error) {
      commit("SET_LOADING", false);
      throw error;
    }
  },
  setSortOption({ commit }, option) {
    commit("SET_SORT_OPTION", option);
  },
};

const getters = {
  playlist: (state) => state.playList,
  playlistSorted: (state) => {
    if (!state.playList) return state.playList;
    return sortStreams(state.playList, state.sortBy);
  },
  currentPlaylist: (state) => {
    const id = router.currentRoute?.value?.params?.playlistId;
    return state.playList?.find((item) => item._id === id);
  },
  hasPlaylist: (state, getters) => {
    if (
      (typeof getters.playlist === "object" && getters.playlist === null) ||
      (getters.playlist != null && Object.keys(getters.playlist).length === 0)
    ) {
      return false;
    } else return true;
  },
  isLoaded: (state) => state.isLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
